import React from 'react';
import {
  Footer,
  MainContainer,
  QuoteBox,
  RedCardContainer,
  UselessTopBar
} from '../components/BackloggeryApp/styles';
import { NowPlaying } from '../components/BackloggeryApp/NowPlaying';
import { Grid2 as Grid } from '@mui/material';
import './backloggery.scss';
import { CuteTitleWithPopout } from '../components/BackloggeryApp/CuteTitleWithPopout';
import { ProgressBarWidget } from '../components/BackloggeryApp/ProgressBarWidget';
import { Library } from '../components/BackloggeryApp/Library';
import { useLibrary } from '../hooks/useLibrary';
import { ConsoleViewLayout } from '../components/BackloggeryApp/ConsoleViewLayout';
import { useHistory } from '../hooks/useHistory';
import { MemoryCardData } from '../components/BackloggeryApp/MemoryCardData';
import _ from 'lodash';
import useBreakpoints from '../hooks/useBreakpoints';

export const BackloggeryApp: React.FC<{ type?: 'list' | 'wishlist' | 'status' | 'all' }> = ({
  type
}) => {
  const { libraryData, nowPlayingData } = useLibrary();
  const { historyData } = useHistory();
  const { isMobile } = useBreakpoints();
  const consoleList = libraryData.map((v) => v.platform);
  const uniqueConsoleList = _.uniq(consoleList);

  const wishlistData = libraryData.filter((el) => el.ownership === 'Wishlist');

  const renderViewtype = (viewtype?: string) => {
    switch (viewtype) {
      case 'list':
        return (
          // <ListViewSkeleton>
          <ConsoleViewLayout platformData={uniqueConsoleList} />
          // </ListViewSkeleton>
        );
      case 'wishlist':
        return (
          // <ListViewSkeleton>
          <ConsoleViewLayout wishlist showInfoBox wishlistData={wishlistData} />
          // </ListViewSkeleton>
        );
      case 'status':
        return (
          // <ListViewSkeleton>
          <ConsoleViewLayout showInfoBox hideProgressBar libraryData={libraryData} />
          // </ListViewSkeleton>
        );
      default:
        return (
          <>
            <Grid container spacing={2}>
              <Grid size={isMobile ? 12 : 7}>
                <RedCardContainer>
                  <CuteTitleWithPopout icon="unfinished">berta&apos;s Status</CuteTitleWithPopout>
                  <ProgressBarWidget data={libraryData} />
                  <Library data={libraryData} />
                </RedCardContainer>
                <RedCardContainer>
                  <CuteTitleWithPopout icon="comments">Dialogue box</CuteTitleWithPopout>
                </RedCardContainer>
              </Grid>
              <Grid size={isMobile ? 12 : 5}>
                <RedCardContainer>
                  <CuteTitleWithPopout>berta</CuteTitleWithPopout>
                </RedCardContainer>
                <RedCardContainer>
                  <CuteTitleWithPopout icon="note">hello there.</CuteTitleWithPopout>
                </RedCardContainer>
                <RedCardContainer>
                  <CuteTitleWithPopout icon="mcard">Memory Card</CuteTitleWithPopout>
                  <MemoryCardData historyData={historyData} />
                </RedCardContainer>
                <RedCardContainer>
                  <CuteTitleWithPopout icon="multitap">Multitap</CuteTitleWithPopout>
                </RedCardContainer>
              </Grid>
            </Grid>
          </>
        );
    }
  };

  return (
    <div className="backloggery-wrap">
      <MainContainer>
        <UselessTopBar />
        <NowPlaying data={nowPlayingData} />
        {renderViewtype(type)}
        <QuoteBox>men cry not for themselves but for their comrades</QuoteBox>
        <Footer>tante care cose</Footer>
      </MainContainer>
    </div>
  );
};
